import script from "./classSchedules.vue?vue&type=script&setup=true&lang=js"
export * from "./classSchedules.vue?vue&type=script&setup=true&lang=js"

import "./classSchedules.vue?vue&type=style&index=0&id=372ea153&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-372ea153"]])

export default __exports__